const { I18n } = require("i18n");

/**
 * create a new instance with it's configuration
 * @ignore
 */

const i18n = new I18n();
i18n.configure({
  defaultLocale: "pt",
  staticCatalog: {
    pt: require("./assets/locales/pt-br").pt,
    en: require("./assets/locales/en-us").en,
  },
  objectNotation: true,
  // setting of log level DEBUG - default to require('debug')('i18n:debug')
  logDebugFn: function (msg) {
    console.log("debug", msg);
  },
  // setting of log level ERROR - default to require('debug')('i18n:error')
  logErrorFn: function (msg) {
    console.error("i18n Error: ", msg);
  },
});

export const lang = (phrase: string, ...params): string =>
  i18n.__(phrase, ...params);
export const catalog = i18n.getCatalog(i18n.getLocale());
export const setLocale = (locale: "pt" | "en") => i18n.setLocale(locale);

export const shortMonths = () => {
  if (i18n.getLocale() === "en")
    return [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

  return [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ];
};

export default i18n;
